// app/_init/useInitApp.ts
'use client'

import useInitTicker from "@/features/ticker/model/useInitTicker"
import { useLoginInit } from "./useloginInit"

export const useInitApp = () => {
  // 다 서버사이드로 빼고 싶지만 스토어 때문에...
  useInitTicker()
  useLoginInit()
}